<template>
  <div>
    <layout-loading v-if="isSubmit" />
    <changeLanguageHeaderTable
      :current-language="currentLanguage"
      @change-language="changeLanguage"
    />
    <BDataTable
      ref="refTable"
      :fetch-list="fetchList"
      :table-columns="tableColumns"
      :filters="filters"
      :pagination="true"
      :create-route="{ name: 'pages-articles-add' }"
      @onGroupDelete="groupDelete"
    >

      <template #cell(status)="{ item }">
        <pill-icon-cell
          :status="$t(`articles.${item.status}`)"
          :options="statusOptions"
        />
      </template>
      <!-- Column: Actions -->
      <template #cell(actions)="{ item }">
        <edit-row @click.native="toEditPage(item._id)" />
        <delete-row @click.native="deleteItem(item._id)" />
      </template>
    </BDataTable>
  </div>
</template>

<script>
import 'bootstrap-vue'
import BDataTable from '@/components/BDataTable/index.vue'
import '@/components/BMediaCustom/index.vue'
import DeleteRow from '@/components/BDataTable/Actions/DeleteRow.vue'
import EditRow from '@/components/BDataTable/Actions/EditRow.vue'
import LayoutLoading from '@/components/LayoutLoading.vue'
import PillIconCell from '@/components/BDataTable/Elements/PillIconCell.vue'
import '@/components/VSelectCustom/index.vue'
import changeLanguageHeaderTable from '@/components/change-language-header-table.vue'
import useArticlesList from './useArticlesList'

export default {
  name: 'ArticlesList',
  components: {
    BDataTable,
    DeleteRow,
    EditRow,
    LayoutLoading,
    PillIconCell,
    changeLanguageHeaderTable,
  },
  setup() {
    const {
      changeLanguage,
      currentLanguage,
      deleteItem,
      fetchList,
      fetchArticlesList,
      groupDelete,
      isSubmit,
      refTable,
      statusOptions,
      tableColumns,
      toEditPage,
      fetchUsersByRole,
    } = useArticlesList()
    return {
      changeLanguage,
      currentLanguage,
      deleteItem,
      fetchList,
      fetchArticlesList,
      groupDelete,
      isSubmit,
      refTable,
      statusOptions,
      tableColumns,
      toEditPage,
      fetchUsersByRole,
    }
  },
  data() {
    return {
      writerOptions: [],
      writerId: null,
      searchT: '',
    }
  },
  computed: {
    filters() {
      return {
        type: 'article',
        writerId: this.writerId && this.writerId._id,
      }
    },
  },
  watch: {
    writerId() {
      this.refTable.refetchData()
    },
    searchT() {
      this.fetchArticlesList(this.form.lang, this.searchT, '')
    },
  },
  created() {
    this.fetchUsersByRole({
      role: 'writer',
    }).then(res => {
      this.writerOptions = res
    })
  },
}
</script>
